import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const PrintDocumentPage = lazy(() =>
  import("@/modules/print").then((m) => ({ default: m.PrintDocumentPage })),
);
const PrintGrRedirectPage = lazy(() =>
  import("@/modules/print").then((m) => ({ default: m.PrintGrRedirectPage })),
);
const Print02VtRedirectPage = lazy(() =>
  import("@/modules/print").then((m) => ({ default: m.Print02VtRedirectPage })),
);
const PrintFormPage = lazy(() =>
  import("@/modules/print").then((m) => ({ default: m.PrintFormPage })),
);
const PrintEbrPage = lazy(() =>
  import("@/modules/print").then((m) => ({ default: m.PrintEbrPage })),
);

export const printRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.DocMasterList,
                  PermissionCodes.DocInstanceList,
                  PermissionCodes.WmsTransactionList,
                  PermissionCodes.SalesOrderList,
                  PermissionCodes.PurchaseOrderList,
                  PermissionCodes.PurchaseRequisitionList,
                  PermissionCodes.QmsInspectionExecute,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "gr/:txnNo",
                element: (
                  <LazyPage>
                    <PrintGrRedirectPage />
                  </LazyPage>
                ),
              },
              {
                path: "02-vt/:txnNo",
                element: (
                  <LazyPage>
                    <Print02VtRedirectPage />
                  </LazyPage>
                ),
              },
              {
                path: "form/:instanceId",
                element: (
                  <LazyPage>
                    <PrintFormPage />
                  </LazyPage>
                ),
              },
              {
                path: "ebr/:batchCode",
                element: (
                  <LazyPage>
                    <PrintEbrPage />
                  </LazyPage>
                ),
              },
              {
                path: ":docCode/:entityKey",
                element: (
                  <LazyPage>
                    <PrintDocumentPage />
                  </LazyPage>
                ),
              },
            ],
          },
];

